import { discardPostDraft } from '../../../actions/discard-post-draft';
import { getPostByIdOrSlug } from '../../../selectors/post-selectors';
import { handlePostDelete } from '../../../services/handle-post-delete';
import { DIALOG_BUTTON_VALUES } from '../constants';
import createMessageHandler from './create-message-hander';

export default createMessageHandler({
  [DIALOG_BUTTON_VALUES.DELETE_POST]: ({ message, environment }) => (dispatch, getState) => {
    const post = getPostByIdOrSlug(getState(), message.data.value.postId);
    dispatch(handlePostDelete({ permanently: false })({ postId: post._id, postStatus: post.status }, environment));
  },
  [DIALOG_BUTTON_VALUES.DISCARD_CHANGES]: ({ message }) => discardPostDraft(message.data.value.postId),
});
